import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { atLeastOneGroupValidator } from '../authentication-method-policy-utlity';
import { AuthenticationMethodsFido2Schema } from './model';

function aaGuidsRequiredWhenEnforced(group: AbstractControl): ValidationErrors | null {
    const isEnforced = group.get('isEnforced')?.value;
    const aaGuids = group.get('aaGuids')?.value;
    if (isEnforced && (!Array.isArray(aaGuids) || aaGuids.length === 0)) {
        return { aaGuidsRequired: true };
    }
    return null;
}

export function initAuthenticationMethodsFido2Form(schema: AuthenticationMethodsFido2Schema): FormGroup {
    const includedGroups = schema.properties?.includeTargets?.items?.oneOf;
    const includedGroupsFormArray = new FormArray([]);

    if (includedGroups?.length > 0) {
        includedGroups.forEach((group) => {
            const groupControl = new FormGroup({
                id: new FormControl(group.properties.id.const),
            });
            includedGroupsFormArray.push(groupControl);
        });
    } else {
        const defaultGroupControl = new FormGroup({
            id: new FormControl('all_users'),
        });
        includedGroupsFormArray.push(defaultGroupControl);
    }

    const keyRestrictionsSchema = schema.properties?.keyRestrictions;

    const formGroup = new FormGroup({
        state: new FormControl(schema.properties.state.const || 'enabled'),
        isSelfServiceRegistrationAllowed: new FormControl(schema.properties?.isSelfServiceRegistrationAllowed?.const),
        isAttestationEnforced: new FormControl(schema.properties?.isAttestationEnforced?.const ?? false),
        keyRestrictions: new FormGroup(
            {
                isEnforced: new FormControl(keyRestrictionsSchema?.properties?.isEnforced?.const ?? false),
                enforcementType: new FormControl(keyRestrictionsSchema?.properties?.enforcementType?.const || 'allow'),
                aaGuids: new FormControl(keyRestrictionsSchema?.properties?.aaGuids?.const || []),
            },
            [aaGuidsRequiredWhenEnforced],
        ),
        includeTargets: new FormGroup(
            {
                includedGroups: includedGroupsFormArray,
                groupInclusion: new FormControl(
                    schema.properties?.includeTargets?.items?.oneOf?.some(
                        (res) => res?.properties?.id?.const !== 'all_users',
                    ) ?? false,
                ),
            },
            [atLeastOneGroupValidator()],
        ),
        excludeTargets: new FormControl(
            schema.properties?.excludeTargets?.items?.oneOf?.map((res) => res.properties.id.const) || [],
        ),
    });

    const includeTargetsGroup = formGroup.get('includeTargets') as FormGroup;
    const includedGroupsArray = includeTargetsGroup?.get('includedGroups') as FormArray;
    if (includedGroupsArray) {
        includedGroupsArray.valueChanges.subscribe(() => {
            includeTargetsGroup?.updateValueAndValidity({ emitEvent: false });
        });
    }

    formGroup.get('state')?.valueChanges.subscribe(() => {
        includeTargetsGroup?.updateValueAndValidity({ emitEvent: false });
    });

    const keyRestrictionsGroup = formGroup.get('keyRestrictions') as FormGroup;
    keyRestrictionsGroup?.get('isEnforced')?.valueChanges.subscribe(() => {
        keyRestrictionsGroup.updateValueAndValidity({ emitEvent: false });
    });

    keyRestrictionsGroup?.get('aaGuids')?.valueChanges.subscribe(() => {
        keyRestrictionsGroup.updateValueAndValidity({ emitEvent: false });
    });

    return formGroup;
}
